module.exports = __webpack_public_path__ + "static/media/map_cluster_marker_blue_4.a6efaf29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map_cluster_marker_blue_4.svg
// module id = 511
// module chunks = 0